(() => {
  const init = (root = document) => {
    root.querySelectorAll('.hx-copy:not([data-copy-ready])').forEach(article => {
      article.dataset.copyReady = 'true';
      const contents = article.querySelector('.hx-copy__contents');
      const mobile = matchMedia('(max-width: 749px)');
      const syncContents = () => { if (contents) contents.open = !mobile.matches; };
      syncContents();
      mobile.addEventListener('change', syncContents);
      const header = document.querySelector('#header-group');
      const offset = () => article.style.setProperty('--copy-offset', `${Math.ceil(header?.getBoundingClientRect().height || 90) + 24}px`);
      offset();
      if (header && window.ResizeObserver) new ResizeObserver(offset).observe(header);
      article.querySelectorAll('.hx-copy__contents a').forEach(link => link.addEventListener('click', event => {
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        if (mobile.matches) contents.open = false;
        history.pushState(null, '', link.hash);
        requestAnimationFrame(() => {
          target.focus({ preventScroll: true });
          target.scrollIntoView({ behavior: 'instant', block: 'start' });
        });
      }));
      article.querySelectorAll('table').forEach((table, i) => {
        const wrap = document.createElement('div');
        wrap.className = 'hx-copy__table';
        if (table.rows[0]?.cells.length > 3) wrap.classList.add('hx-copy__table--wide');
        const title = table.closest('section')?.querySelector('h2');
        if (title) wrap.setAttribute('aria-labelledby', title.id);
        table.before(wrap); wrap.append(table);
        const note = document.createElement('p');
        note.className = 'hx-copy__table-note'; note.id = `CopyTableNote-${i}`;
        note.textContent = article.dataset.tableHint || 'אפשר לגלול את הטבלה לצדדים';
        wrap.before(note);
        const check = () => {
          const wide = table.scrollWidth > wrap.clientWidth + 1;
          note.hidden = !wide;
          if (wide) { wrap.tabIndex = 0; wrap.setAttribute('role', 'region'); wrap.setAttribute('aria-describedby', note.id); }
          else { wrap.removeAttribute('tabindex'); wrap.removeAttribute('role'); wrap.removeAttribute('aria-describedby'); }
        };
        new ResizeObserver(check).observe(wrap); check();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
